import React, { useContext } from 'react';
import { GlobalNavButton } from 'core/nav';
import ModelInfoContext from './ModelInfoContext';

const GlobalNav = () => {
  const { uiPath, brandVariant, brand } = useContext(ModelInfoContext);
  const logoUrl = `${uiPath}/assets/images/logos/${brandVariant}.png`;

  return (
    <div className="global-nav-container">
      <div className="global-nav">
        <div className="global-nav__bar">
          <a
            href="/"
            className="global-nav__brand stat-logo"
            data-dtm="global nav">
            <img className="global-nav__logo" alt={brand} src={logoUrl} />
          </a>
          <div className="global-nav__options">
            <GlobalNavButton
              as="a"
              href={window.appResources.urls.backOutLocationUrl}
              icon="exchange"
              text="Switch Model"
              enable
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalNav;
